import Layout from '@/views/layout/Layout'

export const Dashboard = {
  path: 'dashboard',
  component: () => import('@/card/views/Dashboard'),
  name: 'DashboardIndex',
  meta: {
    title: 'dashboard'
  }
}

export const asyncRouterMap = [
  {
    path: '/user',
    name: 'UserRoot',
    component: Layout,
    children: [
      {
        path: 'info',
        component: () => import('@/card/views/user/Info'),
        name: 'UserInfo',
        meta: {
          title: 'account',
          icon: 'user',
          permissions: ['card.api.user.info']
        }
      },
      {
        path: 'account',
        component: () => import('@/card/views/agent/AgentAccount'),
        name: 'AgentAccount',
        meta: {
          title: 'withdrawals_account',
          icon: 'user',
          permissions: ['card.api.agentaccount.index']
        }
      },
      {
        path: 'maigin',
        component: () => import('@/card/views/user/Margin'),
        name: 'Margin',
        meta: {
          title: 'margin',
          icon: 'file-text',
          permissions: ['card.api.user.margin']
        }
      }
    ],
    meta: {
      title: 'account',
      icon: 'user'
    }
  },
  {
    path: '/agent',
    name: 'AgentRoot',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/card/views/agent/Agent'),
        name: 'Agent',
        meta: {
          title: 'agent',
          icon: 'users',
          permissions: ['card.api.agent.index']
        }
      },
      {
        path: 'packageprice',
        component: () => import('@/card/views/card/PackagePrice'),
        name: 'PackagePriceAll',
        meta: {
          title: 'packageprice',
          icon: 'cubes',
          permissions: ['card.api.packageprice.index']
        }
      },
      {
        path: 'margin',
        component: () => import('@/card/views/agent/AgentMargin'),
        name: 'AgentMargin',
        meta: {
          title: 'package_margin',
          icon: 'file-text',
          permissions: ['card.api.agentmargin.index']
        }
      },
      {
        path: 'interest',
        component: () => import('@/card/views/agent/AgentInterest'),
        name: 'AgentInterest',
        meta: {
          title: 'agentinterest',
          icon: 'file-text',
          permissions: ['card.api.agentinterest.index']
        }
      }
    ],
    meta: {
      title: 'agent',
      icon: 'users',
      permissions: ['card.api.agent.index']
    }
  },
  {
    path: '/client',
    name: 'ClientRoot',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/card/views/agent/Client'),
        name: 'Client',
        meta: {
          title: 'client',
          icon: 'users',
          permissions: ['card.api.client.index']
        }
      },
      {
        path: 'charge',
        component: () => import('@/card/views/client/ClientCharge'),
        name: 'Charge',
        meta: {
          title: 'charge',
          icon: 'file-text',
          permissions: ['card.api.clientcharge.index']
        }
      },
      {
        path: 'charge-item',
        component: () => import('@/card/views/client/ClientChargeItem'),
        name: 'ClientItem',
        meta: {
          title: 'chargeItem',
          icon: 'file-text',
          permissions: ['card.api.clientcharge.index']
        }
      },
      {
        path: 'client-config',
        component: () => import('@/card/views/client/ClientConfig'),
        name: 'client-config',
        meta: {
          title: 'client_config',
          icon: 'file-text',
          permissions: ['card.api.clientconfig.index']
        }
      },
      {
        path: 'client_open_method',
        component: () => import('@/card/views/client/ClientOpenMethod'),
        name: 'ClientOpenMethod',
        meta: {
          title: 'client_open_method',
          icon: 'cloud',
          permissions: ['card.api.clientopenmethod.index']
        }
      },
      {
        path: 'product',
        component: () => import('@/card/views/card/ClientProduct'),
        name: 'client_product',
        meta: {
          title: 'client_product',
          icon: 'briefcase',
          permissions: ['card.api.clientproduct.index']
        }
      },
      {
        path: 'discount',
        component: () => import('@/card/views/client/ClientMargin'),
        name: 'ClientMargin',
        meta: {
          title: 'clientdiscount',
          icon: 'hashtag',
          permissions: ['card.api.clientmargin.index']
        }
      },
      {
        path: 'notify',
        component: () => import('@/card/views/client/ClientNotify'),
        name: 'ClientNotify',
        meta: {
          title: 'clientnotify',
          icon: 'envelope',
          permissions: ['card.api.clientnotify.index']
        }
      }
    ],
    meta: {
      title: 'client',
      icon: 'users',
      permissions: ['card.api.client.index']
    }
  },
  {
    path: '/finance',
    name: 'FinanceRoot',
    component: Layout,
    children: [
      {
        path: 'agent_balance_og',
        component: () => import('@/card/views/agent/AgentBalanceLog'),
        name: 'AgentBalanceLog',
        meta: {
          title: 'rakeback',
          icon: 'line-chart',
          permissions: ['card.api.agent.balancelogs']
        }
      },
      {
        path: 'client_balance_log',
        component: () => import('@/card/views/client/ClientBalanceLog'),
        name: 'ClientBalanceLog',
        meta: {
          title: 'balancelog',
          icon: 'rmb',
          permissions: ['card.api.client.balancelogs']
        }
      },
      {
        path: 'balance_withdrawals',
        component: () => import('@/card/views/agent/AgentBalanceWithdrawals'),
        name: 'BalanceWithdrawals',
        meta: {
          title: 'balancewithdrawals',
          icon: 'sign-out',
          permissions: ['card.api.agentbalancewithdrawals.index']
        }
      },
      {
        path: 'transfer',
        component: () => import('@/card/views/agent/AgentBalanceTransferOrder'),
        name: 'transfer',
        meta: {
          title: 'transfer',
          icon: 'rmb',
          permissions: ['card.api.cardagentbalancetransferorder.index']
        }
      },
      {
        path: 'card_group_balance_log',
        component: () => import('@/card/views/group/GroupBalanceLog'),
        name: 'CardGroupBalanceLog',
        meta: {
          title: 'groupBalanceLog',
          icon: 'rmb',
          permissions: ['card.api.cardgroupbalancelog.index']
        }
      },
      {
        path: 'balance_tax_rate',
        component: () => import('@/card/views/agent/AgentTaxRate'),
        name: 'BalanceTaxRate',
        meta: {
          title: 'balancetaxrate',
          icon: 'file-text',
          permissions: ['card.api.agenttaxrate.index']
        }
      },
      {
        path: 'client_balance_tax_rate',
        component: () => import('@/card/views/client/ClientTaxRate'),
        name: 'ClientBalanceTaxRate',
        meta: {
          title: 'clientbalancetaxrate',
          icon: 'file-text',
          permissions: ['card.api.clienttaxrate.index']
        }
      },
      {
        path: 'withdrawals_account',
        component: () => import('@/card/views/agent/AgentAccountSearch'),
        name: 'WithdrawalsAccount',
        meta: {
          title: 'withdrawals_account_serach',
          icon: 'file-text',
          permissions: ['card.api.agent.getparent']
        }
      }
    ],
    meta: {
      title: 'finance',
      icon: 'rmb'
    }
  },
  {
    path: '/card',
    name: 'CardRoot',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/card/views/card/Card'),
        name: 'CardList',
        meta: {
          title: 'cardlist',
          icon: 'list-ul',
          permissions: ['card.api.card.index']
        }
      },
      {
        path: 'batch/:batch_id',
        component: () => import('@/card/views/card/BatchInfo'),
        name: 'CardBatchInfo',
        meta: {
          title: 'info',
          icon: 'tags',
          permissions: ['card.api.cardbatch.index']
        },
        hidden: true
      },
      {
        path: 'info/:iccid',
        component: () => import('@/card/views/card/Info'),
        name: 'CardInfo',
        meta: {
          title: 'info',
          icon: 'joomla',
          permissions: ['card.api.card.info']
        },
        hidden: true
      },
      {
        path: 'kind',
        component: () => import('@/card/views/card/CardKind'),
        name: 'CardKind',
        meta: {
          title: 'cardkind',
          icon: 'tags',
          permissions: ['card.api.cardkind.index']
        }
      },
      // {
      //   path: 'group',
      //   component: () => import('@/card/views/card/CardGroup'),
      //   name: 'CardGroup',
      //   meta: {
      //     title: 'cardgroup',
      //     icon: 'folder',
      //     permissions: ['card.api.cardgroup.index']
      //   }
      // },
      {
        path: 'batch',
        component: () => import('@/card/views/card/CardBatch'),
        name: 'CardBatch',
        meta: {
          title: 'cardbatch',
          icon: 'sliders',
          permissions: ['card.api.cardbatch.index']
        }
      },
      {
        path: 'location',
        component: () => import('@/card/views/card/CardLocation'),
        name: 'CardLocation',
        meta: {
          title: 'cardlocation',
          icon: 'file-o',
          permissions: ['card.api.cardlocation.index']
        }
      },
      {
        path: 'changecardlog',
        component: () => import('@/card/views/card/ChangeCardLog'),
        name: 'changecardlog',
        meta: {
          title: 'changecardlog',
          icon: 'window-restore',
          permissions: ['card.api.changecardlog.index']
        }
      },
      {
        path: 'package/:iccid',
        component: () => import('@/card/views/card/CardPackage'),
        name: 'CardPackage',
        meta: {
          title: 'cardpackage',
          icon: 'cube',
          permissions: ['card.api.card.packages']
        },
        hidden: true
      },
      {
        path: 'usage/:iccid',
        component: () => import('@/card/views/card/CardUsage'),
        name: 'CardUsage',
        meta: {
          title: 'cardusage',
          icon: 'cube',
          permissions: ['card.api.cardusage.byiccid']
        },
        hidden: true
      },
      {
        path: 'product-config',
        component: () => import('@/card/views/card/CardProductConfig'),
        name: 'ProductConfig',
        meta: {
          title: 'product_config',
          icon: 'tags',
          permissions: ['card.api.cardproductconfig.index']
        }
      },
      {
        path: 'cardtotal/:through_id',
        component: () => import('@/card/views/card/CardTotal'),
        name: 'CardTotal',
        meta: {
          title: 'cardtotal',
          icon: 'tags',
          permissions: ['card.api.cardtotal.index']
        }
      }
    ],
    meta: {
      title: 'card',
      icon: 'credit-card',
      permissions: [
        'card.api.card.index',
        'card.api.changecardlog.index'
      ]
    }
  },
  {
    path: '/group',
    name: 'GroupRoot',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/card/views/group/Group'),
        name: 'CardGroupList',
        meta: {
          title: 'grouplist',
          icon: 'list-ul',
          permissions: ['card.api.cardgroup.index']
        }
      },
      {
        path: 'supplier',
        component: () => import('@/card/views/group/GroupSupplier'),
        name: 'CardGroupSupplier',
        meta: {
          title: 'supplierList',
          icon: 'send-o',
          permissions: ['card.api.groupsupplier.index']
        }
      },
      {
        path: 'view',
        component: () => import('@/card/views/group/CardGroupView'),
        name: 'CardGroupView',
        meta: {
          title: 'cardgroupview',
          icon: 'codepen',
          permissions: ['card.api.cardgroupview.index']
        }
      },
      {
        path: 'batch',
        component: () => import('@/card/views/group/CardGroupBatch'),
        name: 'CardGroupBatch',
        meta: {
          title: 'cardgroupbatch',
          icon: 'sliders',
          permissions: ['card.api.cardgroupbatch.index']
        }
      },
      {
        path: 'salesChannel',
        component: () => import('@/card/views/group/salesChannel'),
        name: 'salesChannelList',
        meta: {
          title: 'groupSalesChannelList',
          icon: 'shower',
          permissions: ['card.api.cardgroupsaleschannel.index']
        }
      },
      {
        path: 'batch/:batch_id',
        component: () => import('@/card/views/group/BatchInfo'),
        name: 'CardGroupBatchInfo',
        meta: {
          title: 'info',
          icon: 'tags',
          permissions: ['card.api.cardgroupbatch.index']
        },
        hidden: true
      },
      {
        path: 'package/:group_id',
        component: () => import('@/card/views/group/CardGroupPackage'),
        name: 'CardGroupPackage',
        meta: {
          title: 'cardgrouppackage',
          icon: 'cube',
          permissions: ['card.api.cardgroup.packages']
        },
        hidden: true
      },
      {
        path: 'deleted_package/:group_id',
        component: () => import('@/card/views/group/DeletedCardGroupPackage'),
        name: 'DeletedCardGroupPackage',
        meta: {
          title: 'deletedcardgrouppackage',
          icon: 'cube',
          permissions: ['card.api.cardgroup.deleted_packages']
        },
        hidden: true
      },
      {
        path: 'total/:through_id',
        component: () => import('@/card/views/group/CardGroupTotal'),
        name: 'CardGroupTotal',
        meta: {
          title: 'cardgrouptotal',
          icon: 'cube',
          permissions: ['card.api.cardgrouptotal.index']
        },
        hidden: true
      }
    ],
    meta: {
      title: 'group',
      icon: 'hdd-o',
      permissions: [
        'card.api.cardgroup.index'
      ]
    }
  },
  {
    path: '/order',
    name: 'orderRoot',
    component: Layout,
    children: [
      {
        path: 'rechargeOrder',
        component: () => import('@/card/views/card/RechargeOrder'),
        name: 'RechargeOrder',
        meta: {
          title: 'rechargeorder',
          icon: 'files-o',
          permissions: ['card.api.rechargeorder.index']
        }
      },
      {
        path: 'refundOrder',
        component: () => import('@/card/views/card/RefundOrder'),
        name: 'RefundOrder',
        meta: {
          title: 'refundorder',
          icon: 'files-o',
          permissions: ['card.api.refundorder.index']
        }
      },
      {
        path: 'rechargeGroupOrder',
        component: () => import('@/card/views/group/RechargeGroupOrder'),
        name: 'RechargeGroupOrder',
        meta: {
          title: 'rechargedeviceorder',
          icon: 'files-o',
          permissions: ['card.api.rechargedeviceorder.index']
        }
      },
      {
        path: 'refundGroupOrder',
        component: () => import('@/card/views/group/RefundGroupOrder'),
        name: 'RefundGroupOrder',
        meta: {
          title: 'refunddeviceorder',
          icon: 'files-o',
          permissions: ['card.api.refunddeviceorder.index']
        }
      },
      {
        path: 'rechargeDevicePresentOrder',
        component: () => import('@/card/views/group/RechargeDevicePresentOrder'),
        name: 'RechargeDevicePresentOrder',
        meta: {
          title: 'groupPresentOrder',
          icon: 'files-o',
          permissions: ['card.api.rechargedevicepresentorder.index']
        }
      },
      {
        path: 'rechargeGroupBalanceOrder',
        component: () => import('@/card/views/group/RechargeGroupBalanceOrder'),
        name: 'RechargeGroupBalanceOrder',
        meta: {
          title: 'deviceBalanceOrder',
          icon: 'files-o',
          permissions: ['card.api.refunddevicebalanceorder.index']
        }
      },
      {
        path: 'refundGroupBalanceOrder',
        component: () => import('@/card/views/group/RefundGroupBalanceOrder'),
        name: 'RefundGroupBalanceOrder',
        meta: {
          title: 'refundDeviceBalanceOrder',
          icon: 'files-o',
          permissions: ['card.api.rechargedevicebalanceorder.index']
        }
      },
      {
        path: 'upgradeGroupOrder',
        component: () => import('@/card/views/group/UpgradeGroupOrder'),
        name: 'UpgradeGroupOrder',
        meta: {
          title: 'upgradedeviceorder',
          icon: 'files-o',
          permissions: ['card.api.upgradedeviceorder.index']
        }
      },
      {
        path: 'ClientOrder',
        component: () => import('@/card/views/client/ClientOrder'),
        name: 'ClientOrder',
        meta: {
          title: 'clientorder',
          icon: 'files-o',
          permissions: ['card.api.clientorder.index']
        }
      },
      {
        path: 'rechargeClientBalanceOrder',
        component: () => import('@/card/views/client/RechargeClientBalanceOrder'),
        name: 'rechargeClientBalanceOrder',
        meta: {
          title: 'rechargeClientBalanceOrder',
          icon: 'files-o',
          permissions: ['card.api.rechargeclientbalanceorder.index']
        }
      },
      {
        path: 'AgentOrder',
        component: () => import('@/card/views/agent/AgentOrder'),
        name: 'AgentOrder',
        meta: {
          title: 'agentorder',
          icon: 'files-o',
          permissions: ['card.api.agentorder.index']
        }
      }
    ],
    meta: {
      title: 'order',
      icon: 'file-text-o',
      permissions: ['card.api.order.index']
    }
  },
  {
    path: '/packageManage',
    name: 'ProductRoot',
    component: Layout,
    children: [
      {
        path: 'package',
        component: () => import('@/card/views/card/Package'),
        name: 'Package',
        meta: {
          title: 'package',
          icon: 'briefcase',
          permissions: ['card.api.package.index']
        }
      },
      {
        path: 'price/:packageId',
        component: () => import('@/card/views/card/PackagePrice'),
        name: 'PackagePrice',
        meta: {
          title: 'packageprice',
          icon: 'cubes',
          permissions: ['card.api.packageprice.index']
        },
        hidden: true
      },
      {
        path: 'happening',
        component: () => import('@/card/views/card/Happening'),
        name: 'Happening',
        meta: {
          title: 'happening',
          icon: 'tags',
          permissions: ['card.api.happening.index']
        }
      },
      {
        path: 'packageitem',
        component: () => import('@/card/views/card/PackageItem'),
        name: 'PackageItem',
        meta: {
          title: 'packageitem',
          icon: 'cubes',
          permissions: ['card.api.packageitem.index']
        }
      }
    ],
    meta: {
      title: 'packageManage',
      icon: 'briefcase',
      permissions: []
    }
  },
  {
    path: '/operateManage',
    name: 'operateRoot',
    component: Layout,
    children: [
      {
        path: 'cardInvoicing',
        component: () => import('@/card/views/operate/CardInvoicing'),
        name: 'cardInvoicing',
        meta: {
          title: 'card_group_invoicing',
          icon: 'file-text-o',
          permissions: ['card.api.cardinvoicing.index']
        }
      },
      {
        path: 'cardGift',
        component: () => import('@/card/views/operate/CardGift'),
        name: 'cardGift',
        meta: {
          title: 'card_gift',
          icon: 'file-text-o',
          permissions: ['card.api.cardgift.index']
        }
      },
      {
        path: 'cardGroupRechargeGift',
        component: () => import('@/card/views/operate/CardGroupRechargeGift'),
        name: 'cardGroupRechargeGift',
        meta: {
          title: 'card_group_recharge_gift',
          icon: 'file-text-o',
          permissions: ['card.api.cardgrouprechargegift.index']
        }
      },
      {
        path: 'cardGroupRechargeGiftLog',
        component: () => import('@/card/views/operate/CardGroupRechargeGiftLog'),
        name: 'cardGroupRechargeGiftLog',
        meta: {
          title: 'card_group_recharge_gift_log',
          icon: 'file-text-o',
          permissions: ['card.api.cardgrouprechargegiftlog.index']
        }
      },
      {
        path: 'supplierPool',
        component: () => import('@/card/views/operate/SupplierPool'),
        name: 'supplierPool',
        meta: {
          title: 'supplier_pool',
          icon: 'tint',
          permissions: ['card.api.supplierpool.index']
        }
      },
      {
        path: 'supplierPoolCalculate',
        component: () => import('@/card/views/operate/SupplierPoolCalculate'),
        name: 'supplierPoolCalculate',
        meta: {
          title: 'supplier_pool_calculate',
          icon: 'bullseye',
          permissions: ['card.api.supplierpool.index']
        }
      },
      {
        path: 'cardNotify',
        component: () => import('@/card/views/operate/CardNotify'),
        name: 'cardNotify',
        meta: {
          title: 'cardNotify',
          icon: 'sliders',
          permissions: ['card.api.cardnotify.index']
        }
      },
      {
        path: 'smsNotify',
        component: () => import('@/card/views/operate/SmsNotifyLog'),
        name: 'smsNotify',
        meta: {
          title: 'smsNotify',
          icon: 'file-text-o',
          permissions: ['card.api.cardsmsnotifylog.index']
        }
      },
      {
        path: 'appNotify',
        component: () => import('@/card/views/operate/AppNotifyLog'),
        name: 'appNotify',
        meta: {
          title: 'appNotify',
          icon: 'file-text-o',
          permissions: ['card.api.cardappnotifylog.index']
        }
      },
      {
        path: 'poolInfo/:pool_id',
        component: () => import('@/card/views/operate/SupplierPoolInfo'),
        name: 'SupplierPoolInfo',
        meta: {
          title: 'supplierPoolInfo',
          icon: 'cube',
          permissions: ['card.api.supplierpool.info']
        },
        hidden: true
      }
    ],
    meta: {
      title: 'operateManage',
      icon: 'th-large'
    }
  },
  {
    path: '/bill',
    name: 'billRoot',
    component: Layout,
    children: [
      {
        path: 'clientBill',
        component: () => import('@/card/views/client/Bill'),
        name: 'ClientBill',
        meta: {
          title: 'clientbill',
          icon: 'files-o',
          permissions: ['card.api.clientbill.index']
        }
      },
      {
        path: 'item/:bill_id',
        component: () => import('@/card/views/client/BillItem'),
        name: 'BillItem',
        meta: {
          title: 'details'
        },
        hidden: true
      }
    ],
    meta: {
      title: 'bill',
      icon: 'file',
      permissions: ['card.api.clientbill.index']
    }
  },
  {
    path: '/supplier',
    name: 'SupplierRoot',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/card/views/supplier/Supplier'),
        name: 'supplierlist',
        meta: {
          title: 'supplierlist',
          icon: 'send-o',
          permissions: ['card.api.supplier.index']
        }
      },
      {
        path: 'supplierbill',
        component: () => import('@/card/views/supplier/SupplierBill'),
        name: 'supplierbill',
        meta: {
          title: 'supplierbill',
          icon: 'send-o',
          permissions: ['card.api.supplierbill.index']
        }
      },
      {
        path: 'supplierbill/:bill_id',
        component: () => import('@/card/views/supplier/SupplierBillInfo'),
        name: 'SupplierBillInfo',
        meta: {
          title: 'info',
          icon: 'tags',
          permissions: ['card.api.supplierbillinfo.index']
        },
        hidden: true
      }
    ],
    meta: {
      title: 'supplier',
      icon: 'send',
      permissions: ['card.api.supplier.index']
    }
  },
  {
    path: '/wechat',
    name: 'WechatRoot',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/card/views/wechat/Wechat'),
        name: 'Wechat',
        meta: {
          title: 'wxpub',
          icon: 'wechat',
          permissions: ['wechat.api.cardapp.index']
        }
      },
      {
        path: 'pay',
        component: () => import('@/card/views/wechat/Pay'),
        name: 'WechatPartner',
        meta: {
          title: 'partner',
          icon: 'wrench',
          permissions: ['wechat.api.pay.index']
        }
      },
      {
        path: 'category',
        component: () => import('@/card/views/wechat/CardProductCategory'),
        name: 'Category',
        meta: {
          title: 'category',
          icon: 'list',
          permissions: ['card.api.cardproductcategory.index']
        }
      },
      {
        path: 'product',
        component: () => import('@/card/views/wechat/CardProduct'),
        name: 'CardProduct',
        meta: {
          title: 'product',
          icon: 'diamond',
          permissions: ['wechat.api.cardproduct.index']
        }
      },
      {
        path: 'equity',
        component: () => import('@/card/views/wechat/UserEquity'),
        name: 'equity',
        meta: {
          title: 'equity',
          icon: 'rmb',
          permissions: ['wechat.api.wechatrights.index']
        }
      },
      {
        path: 'help',
        component: () => import('@/card/views/wechat/Help'),
        name: 'Help',
        meta: {
          title: 'help',
          icon: 'handshake-o',
          permissions: ['card.api.help.index']
        }
      },
      {
        path: 'complain',
        component: () => import('@/card/views/wechat/Complain'),
        name: 'Complain',
        meta: {
          title: 'complain',
          icon: 'user',
          permissions: ['card.api.usercomplain.index']
        }
      },
      {
        path: 'codeConfig',
        component: () => import('@/card/views/wechat/CodeConfig'),
        name: 'codeConfig',
        meta: {
          title: 'codeConfig',
          icon: 'user',
          permissions: ['wechat.api.codeconfig.index']
        }
      }
    ],
    meta: {
      title: 'wechat',
      icon: 'wechat',
      permissions: ['card.api.usercomplain.index']
    }
  },
  {
    path: '/statistics',
    name: 'StatisticsRoot',
    component: Layout,
    children: [
      {
        path: 'changeLog',
        component: () => import('@/card/views/statistics/ChangeLog'),
        name: 'changeLog',
        meta: {
          title: 'change_log',
          icon: 'exchange',
          permissions: ['card.api.cardchangelog.index']
        }
      },
      {
        path: 'usageLog',
        component: () => import('@/card/views/statistics/UsageLog'),
        name: 'usageLog',
        meta: {
          title: 'usage_log',
          icon: 'signal',
          permissions: ['card.api.cardusagelog.index']
        }
      },
      {
        path: 'unbindLog',
        component: () => import('@/card/views/statistics/UnbindLog'),
        name: 'unbindLog',
        meta: {
          title: 'unbindLog',
          icon: 'vcard',
          permissions: ['card.api.cardunbindlog.index']
        }
      },
      {
        path: 'manualRechargeDeviceLog',
        component: () => import('@/card/views/statistics/ManualRechargeDeviceLog'),
        name: 'manualRechargeDeviceLog',
        meta: {
          title: 'manualRechargeDeviceLog',
          icon: 'vcard',
          permissions: ['card.api.manualrechargedevicelog.index']
        }
      },
      {
        path: 'manualRechargeLog',
        component: () => import('@/card/views/statistics/ManualRechargeLog'),
        name: 'manualRechargeLog',
        meta: {
          title: 'manualRechargeLog',
          icon: 'vcard',
          permissions: ['card.api.manualrechargelog.index']
        }
      }
    ],
    meta: {
      title: 'statistics',
      icon: 'bar-chart',
      permissions: ['card.api.statistics.index']
    }
  },
  {
    path: '/task',
    name: 'TaskRoot',
    component: Layout,
    children: [
      {
        path: 'download',
        component: () => import('@/card/views/task/DownloadTask'),
        name: 'download',
        meta: {
          title: 'download_task',
          icon: 'download',
          permissions: ['card.api.carddownloadtask.index']
        }
      },
      {
        path: 'handle',
        component: () => import('@/card/views/task/HandleTask'),
        name: 'handle_task',
        meta: {
          title: 'handle_task',
          icon: 'tasks',
          permissions: ['card.api.cardhandletask.index']
        }
      },
      {
        path: 'handle/:task_id',
        component: () => import('@/card/views/task/HandleTaskInfo'),
        name: 'handle_task_info',
        meta: {
          title: 'handle_task_info',
          permissions: ['card.api.cardhandletaskinfo.index']
        },
        hidden: true
      },
      {
        path: 'polling',
        component: () => import('@/card/views/task/PollingTask'),
        name: 'polling',
        meta: {
          title: 'polling_task',
          icon: 'repeat',
          permissions: ['sys.api.task.index']
        }
      }
    ],
    meta: {
      title: 'task',
      icon: 'bar-chart'
    }
  },
  {
    path: '/system',
    name: 'System',
    component: Layout,
    meta: {
      title: 'system',
      icon: 'gear',
      permissions: [
        'auth.api.user.index',
        'auth.api.role.index',
        'auth.api.catelog.index',
        'auth.api.auth.permissions',
        'auth.api.auth.changepassword'
      ]
    },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/Profile'),
        name: 'SystemProfile',
        meta: { title: 'profile' },
        permissions: ['auth.api.auth.changepassword']
        // hidden: true
      },
      {
        path: 'notice',
        component: () => import('@/views/Notice'),
        name: 'SystemNotice',
        meta: {
          title: 'notice',
          permissions: ['auth.api.notice.index']
        },
        hidden: true
      },
      {
        path: 'user',
        component: () => import('@/views/user/User'),
        name: 'UserIndex',
        meta: {
          title: 'user',
          icon: 'user',
          permissions: ['auth.api.user.index']
        }
      },
      {
        path: 'role',
        component: () => import('@/views/auth/Role'),
        name: 'PermissionRole',
        meta: {
          title: 'role',
          icon: 'users',
          permissions: ['auth.api.role.index']
        }
      },
      {
        path: 'menu',
        component: () => import('@/views/auth/Menu'),
        name: 'AuthMenu',
        meta: {
          title: 'menu',
          icon: 'bars',
          permissions: ['auth.api.menu.index']
        }
      },
      {
        path: 'catelog',
        component: () => import('@/views/catelog/Catelog'),
        name: 'CatelogIndex',
        meta: {
          title: 'catelog',
          icon: 'list',
          permissions: ['auth.api.catelog.index']
        }
      },
      {
        path: 'permission',
        component: () => import('@/views/auth/Permission'),
        name: 'PermissionIndex',
        meta: {
          title: 'permission',
          icon: 'lock',
          permissions: ['auth.api.auth.permissions']
        }
      },
      {
        path: 'sysconfig',
        component: () => import('@/views/SysConfig'),
        meta: {
          title: 'sysconfig',
          icon: 'wrench',
          permissions: ['auth.api.sysconfig.index']
        }
      },
      {
        path: 'optlog',
        component: () => import('@/views/OptLog'),
        name: 'OptlogIndex',
        meta: {
          title: 'optlog',
          icon: 'book',
          permissions: ['auth.api.authoperationlog.index']
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/card/router/index.js